import axios from './axios';
import { Query, buildQuery } from '../utils/query';
import { MimeType } from '../redux/types/mime';

export const loadProperties = (queryObject?: Query) => {
  const query = buildQuery(queryObject);

  return axios.get(`/properties${query}`);
};

export const loadPropertyById = (id: number | string) => axios.get(`/properties/${id}`);

export const loadPropertiesExport = (
  selection: Array<number | string>,
  mimeType: MimeType,
) => {
  const headers = {
    Accept: mimeType,
  };

  return axios.post(
    '/properties/export',
    {
      selection,
    },
    { headers, responseType: 'blob' },
  );
};
